import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FeCollapse from '../FeCollapse/FeCollapse';
import CollapseIcon from '../CollapseIcon/CollapseIcon';
import AwesomeCheckbox from '../AwesomeCheckbox/AwesomeCheckbox';
import './ListFilterGroup.css';

class ListFilterGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilterGroupOpen: true,
      isListOpen: false,
      isOverHeight: false,
      selected: props.selected
    };
    this.toggleSeeAll = this.toggleSeeAll.bind(this);
    this.toggleFilterGroup = this.toggleFilterGroup.bind(this);
    this.isItemSelected = this.isItemSelected.bind(this);
    this.onItemCheckedChanged = this.onItemCheckedChanged.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const { initiallyVisible, list } = props;
    let newState = { selected: props.selected };
    newState.isOverHeight = initiallyVisible > 0 && list.length > initiallyVisible;

    // If an item that should be hidden is selected, open the FilterGroup
    if (!state.isListOpen && state.isOverHeight) {
      newState.selected.forEach(sl => {
        newState.isListOpen = list.slice(initiallyVisible).some(s => {
          return sl.id === s.id;
        });
      });
    }
    return newState;
  }

  toggleSeeAll(event) {
    this.setState({ isListOpen: event.target.checked });
  }

  toggleFilterGroup() {
    this.setState({ isFilterGroupOpen: !this.state.isFilterGroupOpen });
  }

  isItemSelected(item) {
    return this.state.selected.map(v => v.id).includes(item.id);
  }

  onItemCheckedChanged(item, checked) {
    const { selected } = this.state;
    let selectionSet = selected.slice(0);

    if (checked && !selectionSet.find(s => s.id === item.id)) {
      selectionSet.push(item);
    } else {
      selectionSet = selectionSet.filter(s => s.id !== item.id);
    }

    if (this.props.onClick) this.props.onClick(this.props.group, selectionSet);
  }

  render() {
    const { group, name, list } = this.props;
    const { isFilterGroupOpen, isListOpen, isOverHeight } = this.state;

    const isOpen = isFilterGroupOpen && list && list.length > 0;

    return (
      <div className="filter-group">
        <div id={group} className="filter-group__title" onClick={this.toggleFilterGroup}>
          <div className="filter-group__title-text" role="button" tabIndex="0" title={name}>
            <CollapseIcon className="filter-group__title-text--icon" fixedWidth isOpen={isOpen} /> {name}
          </div>
        </div>
        <FeCollapse className={classNames('filter-group__collapse', { 'over-height': isOverHeight })} isOpen={isOpen}>
          <input
            type="checkbox"
            className="filter-group__collapse--see-all-state"
            id={`${group}-see-all`}
            checked={isListOpen}
            onChange={this.toggleSeeAll}
          />
          <ul className="filter-group__collapse--list">
            {list.map((item, i) => {
              return (
                <li key={item.id}>
                  <AwesomeCheckbox
                    onChange={checked => this.onItemCheckedChanged(item, checked)}
                    checked={this.isItemSelected(item)}
                    value={item.id}
                  >
                    {item.name}
                  </AwesomeCheckbox>
                </li>
              );
            })}
          </ul>
          <label htmlFor={`${group}-see-all`} className="filter-group__collapse--see-all-label" />
        </FeCollapse>
      </div>
    );
  }
}

ListFilterGroup.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  group: PropTypes.string.isRequired,
  initiallyVisible: PropTypes.number,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  selected: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  ).isRequired
};

ListFilterGroup.defaultProps = {
  name: '',
  initiallyVisible: 6,
  list: [],
  selected: []
};

ListFilterGroup.displayName = 'ListFilterGroup';

export default ListFilterGroup;
